import CashCollectionBreakdown from 'src/features/cashCollections/components/forms/CashCollectionBreakdown';
import CollectionDetails from 'src/features/cashCollections/components/forms/CollectionDetails';
import { Form } from 'src/registry/ui/Form';

import type { UseFormReturn } from 'react-hook-form';
import type { CreateCashCollectionFormSchemaValues } from 'src/features/cashCollections/hooks/useCreateCashCollection';

interface CashCollectionFormProps {
    form: UseFormReturn<CreateCashCollectionFormSchemaValues>;
    onSubmit: () => void;
    isEditModal: boolean;
}

const CashCollectionForm = ({ form, onSubmit, isEditModal = false }: CashCollectionFormProps) => {
    const selectedPayStation = form.getValues('paystation');
    return (
        <Form form={form} variant="dialog" onSubmit={form.handleSubmit(onSubmit)}>
            <CollectionDetails form={form} isEditModal={isEditModal} />
            {selectedPayStation && <CashCollectionBreakdown form={form} />}
        </Form>
    );
};

export default CashCollectionForm;
